import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';

import { routesSection } from 'src/routes/sections';

import { themeConfig, ThemeProvider } from 'src/theme';

import { defaultSettings, SettingsProvider } from 'src/components/settings';

import App from './App';
import ErrorPage from './pages/ErrorPage';
import { msalInstance } from './utils/auth';

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorPage />,
    children: routesSection,
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <SettingsProvider defaultSettings={defaultSettings}>
        <ThemeProvider noSsr defaultMode="light" modeStorageKey={themeConfig.modeStorageKey}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </SettingsProvider>
    </MsalProvider>
  </React.StrictMode>
);
